/**
 * @generated SignedSource<<0ea80a3fdf5b15c2c7944b5c43fdb1e8>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "model",
            "variableName": "model"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "AssetAssignmentTypesPanel_removeAssignmentTypesFromAssetMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "RemoveAssignmentTypesFromAssetPayload",
                    "kind": "LinkedField",
                    "name": "removeAssignmentTypesFromAsset",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Asset",
                            "kind": "LinkedField",
                            "name": "asset",
                            "plural": false,
                            "selections": [
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "AssetAssignmentTypesPanel_asset"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "AssetAssignmentTypesPanel_removeAssignmentTypesFromAssetMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "RemoveAssignmentTypesFromAssetPayload",
                    "kind": "LinkedField",
                    "name": "removeAssignmentTypesFromAsset",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Asset",
                            "kind": "LinkedField",
                            "name": "asset",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AssignmentTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "assignmentTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "AssignmentType",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                (v2 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "title",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                (v2 /*: any*/)
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "4036f972f95cd199cf81194de22de729",
            "id": null,
            "metadata": {},
            "name": "AssetAssignmentTypesPanel_removeAssignmentTypesFromAssetMutation",
            "operationKind": "mutation",
            "text": "mutation AssetAssignmentTypesPanel_removeAssignmentTypesFromAssetMutation(\n  $model: RemoveAssignmentTypesFromAssetInput!\n) {\n  removeAssignmentTypesFromAsset(model: $model) {\n    asset {\n      ...AssetAssignmentTypesPanel_asset\n      id\n    }\n  }\n}\n\nfragment AssetAssignmentTypesPanel_asset on Asset {\n  assignmentTypes {\n    nodes {\n      id\n      title\n    }\n  }\n  id\n}\n"
        }
    };
})();
node.hash = "153f4ce616767e04c8201f202d8efaa2";
export default node;
